let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("8IC4b")]).then(() => parcelRequire('3R5ta'));